<template>
  <Layout>
    <main class="main-wrap ">
      <div class="min-s-hight setting_width">
        <section class="r-s-wrap">
          <div class="container devExtremeGridContainer">
            <div class="row">
              <div class="col-10 col-sm-8 col-md-8 col-lg-9">
                <h2 class="color-black mr-b30 pageHeading"
                  >Set our default margin
                  <img
                    src="/images/info.png"
                    alt=""
                    title="Set our default margin"
                /></h2>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="services-tabs">
                  <div class="cus-tabs">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs mb-4">
                      <li class="nav-item cursor-pointer ml-0">
                        <a
                          class="nav-link ml-0"
                          :class="{ active: tabNumber === 1 }"
                          data-toggle="tab"
                          @click="changeTab(1)"
                          >Global default margin</a
                        >
                      </li>

                      <li class="nav-item cursor-pointer ">
                        <a
                          class="nav-link"
                          :class="{ active: tabNumber === 2 }"
                          data-toggle="tab"
                          @click="changeTab(2)"
                        >
                          Vendor-specific margin</a
                        >
                      </li>

                      <li class="nav-item cursor-pointer ">
                        <a
                          class="nav-link"
                          :class="{ active: tabNumber === 3 }"
                          data-toggle="tab"
                          @click="changeTab(3)"
                          >Service-specific margin</a
                        >
                      </li>
                    </ul>

                    <transition name="fade">
                      <allMargin v-if="tabNumber === 1"></allMargin>
                    </transition>
                    <transition name="fade">
                      <vendorMargin v-if="tabNumber === 2"></vendorMargin>
                    </transition>
                    <transition name="fade">
                      <serviceMargin v-if="tabNumber === 3"></serviceMargin>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import allMargin from '@src/payment/margin/allMargin.vue'
import vendorMargin from '@src/payment/margin/vendorMargin.vue'
import serviceMargin from '@src/payment/margin/serviceMargin.vue'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { superAdminMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Vendor List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout: Layout,
    allMargin,
    vendorMargin,
    serviceMargin,
  },

  data() {
    return {
      tabNumber: 1,
      providerId: 0,
      providerName: '',
    }
  },

  created() {},

  methods: {
    ...superAdminMethods,

    // -------------------------------------------------------------------------------------------------------
    changeTab(val) {
      this.tabNumber = val
    },
    // -------------------------------------------------------------------------------------------------------
    changeCurrentTabForService(val) {
      this.providerId = val.providerID
      this.providerName = val.providerName
      this.tabNumber = val.tabNumber
    },
    // -------------------------------------------------------------------------------------------------------
    //  Redirection to handle Service Distribution
    mapBuildingservice(data) {
      this.$router.push({
        name: 'manageServiceform',
        query: {
          FacId: data.FacID,
          FacName: data.FacName,
        },
      })
    },
  },
}
</script>

<style scoped>
@media (max-width: 576px) {
  .pageHeading {
    font-size: 26px;
  }
}
</style>
